import React from "react";
var __jsx = React.createElement;
import Image from '../../atoms/Image';
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return __jsx(Image, {
    alt: "",
    src: "/svg/".concat(name, ".svg"),
    width: size,
    height: size
  });
};
export default Icon;